// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2Z0T9","title":"AfterFrontImage_title__1duW2"};